module.exports = __webpack_public_path__ + "static/sports_mobile_app_cover-99f9098aa517643d9d2e8260b9616d4f.png";